const INCREMENT_COUNTER = '@app/INCREMENT_COUNTER';
const DECREMENT_COUNTER = '@app/DECREMENT_COUNTER';

export { INCREMENT_COUNTER, DECREMENT_COUNTER };
